<template>
    <div :class="[{'mass': theme == 'mass'}, {'prestige': theme == 'prestige'}]">
        <div v-if="campaignImage && campaignImage.length > 1">
            <carousel id="detail_carousel"
                :responsive="carouselConfig.responsive"
                :lazyLoad="true"
                :nav="false"
                :rewind="false"
                :loop="true"
                :autoplay="true"
                :item="1">
                <div class="detail-img"
                    :class="imgCampaignClass"
                    v-for="(image, k) in campaignImage" :key="k">
                    <img :src="image.fullImageUrl" class="img-fluid" />
                </div>
            </carousel>
        </div>
    <div class="detail-img"
        :class="imgCampaignClass"
        v-if="campaignImage && campaignImage.length == 1">
        <img :src="campaignImage[0].fullImageUrl" class="img-fluid" />
    </div>
</div>
</template>

<script>
import Carousel from "vue-owl-carousel";

export default {
    name: "Picture",
    components: {
        Carousel
    },
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    props: {
        imgClass: String,
        campaignImage: Array
    },
    data: function() {
        return {
            imgCampaignClass: '',
            carouselConfig: {
                responsive: {
                0: { items: 1 }
                }
            }
        };
    },
    created: function () {
        this.imgCampaignClass = this.imgClass || 'default';
    }
};
</script>
<style lang="scss" scoped>

</style>
<style lang="scss">
    @import "@/style/base/base.scss";
    @import "@/style/custom/owl.scss";
    .detail-img {
        width: 100%;

        &.default {
            @include baseRatioImg(75%);
        }
    }

    .mass {
        #detail_carousel {
            @include owlDetail(rgba(255, 255, 255, 0.5), $mass_theme_color);
        }
    }

    .prestige {
        #detail_carousel {
            @include owlDetail(rgba(255, 255, 255, 0.5), $prestige_theme_color);
        }
    }
</style>

